import { toUpper } from 'ramda';

import { NAME } from './constants';

const capsName = toUpper(NAME);

const actionTypes = {
	SET_TABLE_DATA: `${capsName}_SET_TABLE_DATA`,
	APPEND_TABLE_DATA: `${capsName}_APPEND_TABLE_DATA`,
	REMOVE_TABLE: `${capsName}_REMOVE_TABLE`,
};

export default actionTypes;
